module.exports = {
  title: 'React Native Floating Bottom Bar Animation 🚀',
  author: 'Enzo Manuel Mangano',
  date: '2023-01-18',
  slug: 'floating-bottom-bar',
  tags: ['skia', 'reanimated', 'react-navigation'],
};
